import React from 'react';
import styles from './Header.module.scss';
import {ReactComponent as LogoColor} from '../../assets/logo-color.svg';
import { Link } from '../ui/Link';
import { TwitterButton } from '../ui/TwitterButton';
import { GLOBAL, GlobalDispatcher } from '../../App';

export class Header extends React.Component
{

	componentDidMount()
	{
		GlobalDispatcher.on('route_change', this._routeChange);
	}

	componentWillUnmount()
	{
		GlobalDispatcher.off('route_change', this._routeChange);


	}

	private _routeChange = (e) =>
	{
		this.setState({});
	}

	render()
	{

		return (
			<header className={styles['header']}>
				<div className={styles['top']}>
					<Link decoration={false} href={'/'} arrow={false} className={'hide-small'}>
						PLATEAU EVENT WEB SITE
					</Link>
					<Link decoration={false} arrow={false} href={'/'}>
						<LogoColor className={styles['logo']}></LogoColor>
					</Link>
					{
						(GLOBAL.router?.currentPath == '/')?
						(
							// <Link decoration={false} arrow={false} href={'/award'} className={[styles['top-button'], 'hide-small', 'round', 'theme-black', 'white'].join(' ')}>
							// 	PLATEAU AWARD 特設ページへ
							// </Link>
							<TwitterButton className={'middle'}></TwitterButton>
							):
							(null
							// <Link decoration={false} arrow={true} href={'https://connpass.com/event/303782/'} className={[styles['top-button'], 'hide-small', 'round', 'theme-purple', 'white'].join(' ')}>
							// 	最終審査会一般観覧受付中
							// </Link>
						)
					}
				</div>
				<div className={styles['bottom']}>
					{
						(GLOBAL.router?.currentPath == '/')?
						(null
							// <Link decoration={false} arrow={false} href={'/award'} className={[styles['top-button'], 'show-small', 'round', 'theme-black', 'white'].join(' ')}>
							// 	PLATEAU AWARD 特設ページへ
							// </Link>
							// <TwitterButton className='middle'></TwitterButton>
						):(
							<>
								{/* <Link decoration={false} arrow={true} href={'https://connpass.com/event/303782/'} className={[styles['top-button'], 'show-small', 'round', 'theme-purple', 'white'].join(' ')}>
								最終審査会一般観覧受付中
								</Link> */}
								<TwitterButton></TwitterButton>
							</>
						)
					}
				</div>
			</header>
		)
	}
}